import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LoginPage from "@/pages/login/page";
import GeneratePage from "@/pages/generate/page";
import MembershipPage from "@/pages/membership/page";
import ProfilePage from "@/pages/profile/page";
import ProfileEditPage from "@/pages/profile/ProfileEditPage";
import SettingsPage from "@/pages/settings/page";
import AppLayout from "@/components/feature/AppLayout";
import GalleryPage from "@/pages/gallery/page";
import MoreTools from "@/pages/tools/page";
import BgReplacePage from "@/pages/tools/bg-replace/page";
import BgCleanPage from "@/pages/tools/bg-clean/page";
import ClothExtractPage from "@/pages/tools/cloth-extract/page";
import OutpaintPage from "@/pages/tools/outpaint/page";
import WatermarkRemovePage from "@/pages/tools/watermark-remove/page";
import ColorizePage from "@/pages/tools/colorize/page";
import ObjectRemovePage from "@/pages/tools/object-remove/page";
import StyleTransferPage from "@/pages/tools/style-transfer/page";
import LegacyGenerationTaskRedirect from "@/router/LegacyGenerationTaskRedirect";

const routes: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/profile", element: <ProfilePage /> },
    ],
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/generate",
    element: <GeneratePage />,
  },
  {
    path: "/generate/tasks",
    element: <LegacyGenerationTaskRedirect />,
  },
  {
    path: "/generate/tasks/:genId",
    element: <LegacyGenerationTaskRedirect />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/profile/edit",
    element: <ProfileEditPage />,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
  },
  {
    path: "/tools",
    element: <MoreTools />,
  },
  {
    path: "/bg-replace",
    element: <BgReplacePage />,
  },
  {
    path: "/bg-clean",
    element: <BgCleanPage />,
  },
  {
    path: "/cloth-extract",
    element: <ClothExtractPage />,
  },
  {
    path: "/outpaint",
    element: <OutpaintPage />,
  },
  {
    path: "/watermark-remove",
    element: <WatermarkRemovePage />,
  },
  {
    path: "/colorize",
    element: <ColorizePage />,
  },
  {
    path: "/object-remove",
    element: <ObjectRemovePage />,
  },
  {
    path: "/style-transfer",
    element: <StyleTransferPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
